import { mqMin, tokPx } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

const TypographyText = styled(Typography)`
  // Using !important due to styled-components specificity issues when used in combination with UDS Typography component
  margin-bottom: ${tokPx('primitives_space_12')}!important;

  @media (${mqMin('primitives_breakpoint_l_min')}) {
    ${Typography.modVariant('display-f-regular')};
  }
`

export function HeadingLabel({ text }: { text?: string }) {
  if (!text) {
    return null
  }

  return <TypographyText $variant="display-g-regular" as="h2">{text}</TypographyText>
}
